var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"version-details"},[_c('ModulesForVersionList',{attrs:{"version":_vm.versionObj,"title":("Modules available in " + _vm.computedVersionName + " version")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }